export default "__VITE_ASSET__BSQJoIHu__"